export const oidcConfig = {
  authority: import.meta.env.VITE_AAD_AUTHORITY ?? "",
  client_id:  import.meta.env.VITE_AAD_CLIENTID ?? "", 
  redirect_uri: import.meta.env.VITE_LOGIN_REDIRECT_URI ?? "",
  code_verifier: true,
  noonce: true,
  response_type: 'code',
  scope: import.meta.env.VITE_AAD_SCOPES,
  onSigninCallback: (_user:any | void) : void => {
    console.log('onSigninStaffCallback');
  }
}